export default __webpack_public_path__ + "static/media/movie.1700363c.png";